import http from '../http/common'

const resource = '/pabau-sales-dashboard'

export default {

	salesDashboard: (payload) => http.post(`${resource}`, payload)
}
